import logo from './logo.svg';
import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
  const [htmlFiles, setHtmlFiles] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [htmlContent, setHtmlContent] = useState('');

  // Configuration - Update these with your target repository
  const GITHUB_OWNER = "dom-liu";
  const GITHUB_REPO = "deepseek-r1-demo";
  const GITHUB_BRANCH = "main";

  const fetchHtmlFiles = async () => {
    try {
      const response = await fetch(
        `https://api.github.com/repos/${GITHUB_OWNER}/${GITHUB_REPO}/contents?ref=${GITHUB_BRANCH}`
      );
      
      if (!response.ok) return;

      const files = await response.json();
      const htmlFiles = files.filter(
        file => file.type === 'file' && file.name.endsWith('.html')
      );

      setHtmlFiles(htmlFiles);
      
      // Auto-select first file if none selected
      if (htmlFiles.length > 0 && !selectedFile) {
        fetchFileContent(htmlFiles[0]);
      }
    } catch (error) {
      console.error('Error fetching files:', error);
    }
  };

  const fetchFileContent = async (file) => {
    try {
      const response = await fetch(file.download_url);
      if (!response.ok) return;
      const content = await response.text();
      setHtmlContent(content);
      setSelectedFile(file);
    } catch (error) {
      console.error('Error fetching content:', error);
    }
  };

  useEffect(() => {
    fetchHtmlFiles();
  }, []);

  return (
    <div className="App">
      <header className="App-header">
        <h1>deepseek-r1-0528-demo</h1>
        
        <div className="controls">
          <button onClick={fetchHtmlFiles} className="refresh-btn">
            Refresh Files
          </button>
        </div>
        
        <div className="file-browser">
          {htmlFiles.length > 0 && (
            <div className="file-list">
              <h3>HTML Files:</h3>
              <ul>
                {htmlFiles.map(file => (
                  <li 
                    key={file.sha} 
                    onClick={() => fetchFileContent(file)}
                    className={selectedFile?.path === file.path ? 'selected' : ''}
                  >
                    {file.name}
                  </li>
                ))}
              </ul>
            </div>
          )}
          
          <div className="html-preview">
            {htmlContent ? (
              <iframe
                title="html-preview"
                srcDoc={htmlContent}
                sandbox="allow-scripts"
              />
            ) : (
              <div className="empty-state">
                <p>Select an HTML file to preview</p>
              </div>
            )}
          </div>
        </div>
      </header>
    </div>
  );
}

export default App;